// import { Modal, ModalBody, ModalHeader } from "reactstrap"; 
// function ViewImgAndPdf({
//   isOpen,
//   toggleModal,
//   titleName,
//   images,
//   currentImageIndex,
//   fileType,
// }) {
//   const currentImage = images?.[currentImageIndex] || "";

//   const isPdf = ["pdf", "application/pdf"].includes(fileType); 

//   return (
//     <Modal isOpen={isOpen} toggle={toggleModal} size="lg">
//       <ModalHeader toggle={toggleModal}>{titleName}</ModalHeader>
//       <ModalBody>
//         {currentImage && (
//           <div style={{ textAlign: "center" }}>
//             {isPdf ? (
//               <iframe
//                 className="img-thumbnail"
//                 src={currentImage}
//                 style={{ height: "600px", width: "800px", objectFit: "cover" }}
//                 title="PDF Preview"
//               />
//             ) :  (
//               <img
//                 className="img-thumbnail"
//                 src={currentImage}
//                 alt="Selected"
//                 style={{
//                   height: "auto",
//                   maxHeight: "600px",
//                   width: "650px",
//                   objectFit: "cover",
//                 }}
//               />
//             )}
//           </div>
//         )}
//       </ModalBody>
//     </Modal>
//   );
// }

// export default ViewImgAndPdf;

import { Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from "reactstrap";
import { Button, Icon } from "../../../components/Component";
function ViewImgAndPdf({
  isOpen,
  toggleModal,
  titleName,
  images,
  currentImageIndex,
  fileType,
  setValue,
  approve,
  isLoading,
  image,
  getValues,
  trigger,
  watch,
  image_url,
}) {
  const currentImage = images?.[currentImageIndex] || "";

  const isPdf = ["pdf", "application/pdf"].includes(fileType);
  const isExcelFile = [
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ].includes(fileType);

  // Get current values
  const objectionKeys = getValues("objectionKeys") || [];

  // Approve: remove key from objectionKeys
  const handleApprove = (key) => {
    const updatedObjections = objectionKeys.filter((item) => item !== key);
    setValue("objectionKeys", updatedObjections);
    trigger("objectionKeys"); // Optional: trigger validation or re-render
  };

  // Reject: add key to objectionKeys if not already there
  const handleReject = (key) => {
    if (!objectionKeys.includes(key)) {
      const updatedObjections = [...objectionKeys, key];
      setValue("objectionKeys", updatedObjections);
      trigger("objectionKeys");
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggleModal} size="lg">
      <ModalHeader toggle={toggleModal}>{titleName}</ModalHeader>
      <ModalBody>
        {currentImage && (
          <div style={{ textAlign: "center" }}>
            {isPdf ? (
              <iframe
                className="img-thumbnail"
                src={currentImage}
                style={{ height: "600px", width: "800px", objectFit: "cover" }}
                title="PDF Preview"
              />
            ) : isExcelFile ? (
              <Button
                outline
                color="success"
                type="button"
                size="sm"
                title="Download Excel"
                onClick={() => window.open(watch(image_url), "_blank")}
                style={{
                  border: objectionKeys.includes(image) && "2px solid crimson",
                }}
              >
                <Icon name="file-xls" /> {/* Excel icon */}
              </Button>
            ) : (
              <img
                className="img-thumbnail"
                src={currentImage}
                alt="Selected"
                style={{
                  height: "auto",
                  maxHeight: "600px",
                  width: "650px",
                  objectFit: "cover",
                }}
              />
            )}
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        {approve && (
          <>
            <div className="d-flex">
              <div className="form-group" style={{ marginTop: "31px" }}>
                <Button color="primary" size="md" onClick={() => handleApprove(image)}>
                  {isLoading ? <Spinner size="sm" color="light" /> : "Approve"}
                </Button>
              </div>

              <div className="form-group mx-2" style={{ marginTop: "31px" }}>
                <Button
                  color="primary"
                  size="md"
                  onClick={() => handleReject(image)}
                  disabled={objectionKeys.includes(image)} // Disable if already rejected
                >
                  {isLoading ? <Spinner size="sm" color="light" /> : "Reject"}
                </Button>
              </div>
            </div>
          </>
        )}
      </ModalFooter>
    </Modal>
  );
}

export default ViewImgAndPdf;
